export default __webpack_public_path__ + "static/media/eye-closed.0de5cdd7.svg";